import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { MaskInput } from '@alfa-bank/site-mask-input';
import { IncreaseDecreaseInput } from '@alfa-bank/site-increase-decrease-input';

import type { TIncreaseDecreaseInput, IDeps } from './models';
import { IncreaseDecreaseInputMask as Component } from './increase-decrease-input-mask';

export const IncreaseDecreaseInputMask = createWidget<IDeps, TIncreaseDecreaseInput>({
    MaskInput,
    IncreaseDecreaseInput,
})(Component);
